<template>
  <div class="mine-page">
    <div class="title fixed" v-if="!hideTopBar">{{i18n.t('mine.title')}}</div>

    <div class="top-info " style="padding-top: 1.5rem">
      <div class="flex-center-start">
        <div class="avatar" v-if="isLogin">{{username.substring(0,1)}}</div>
        <div class="avatar black" v-if="!isLogin">F</div>
        <div class="" v-if="isLogin">
          <div class="name">{{resetEmail(username)}}</div>
          <div class="desc flex-center-start">
            <span>UID：{{userId}}</span>
            <span class="tag green" v-if="RealNameStatus == '1'">{{$t('mine.label1')}}</span>
            <span class="tag red" v-if="RealNameStatus == '3'">{{$t('mine.label2')}}</span>
            <span class="tag yellow" v-if="RealNameStatus == '2'">{{$t('mine.label3')}}</span>
          </div>
        </div>
        <div class="" v-if="!isLogin">
          <div class="name">{{$t('mine.desc1')}}</div>
          <div class="desc">{{$t('mine.desc2')}}</div>
        </div>
      </div>

      <div  v-if="!isLogin">
        <Button class="btn" @click="toPath('login')">{{$t('mine.btn')}}</Button>
      </div>
    </div>

    <div class="space-line"></div>

    <div class="menu-box" v-show="isLogin">
      <div class="menu-title">{{$t('mine.tab1')}}</div>
      <div class="menu-list">
        <div class="menu flex-column-center" v-for="(menu, i) in menuList" :key="i" @click="toPath(menu.path, menu.query)" v-if="menu.name && menu.url">
          <img :src="menu.url" alt="">
          <div>{{menu.name}}</div>
        </div>
      </div>

       <div class="menu-title">{{$t('mine.tab2')}}</div>
      <div class="menu-list">
        <div class="menu flex-column-center" v-for="(menu, i) in menuList2" :key="i" @click="toPath(menu.path)" v-if="menu.name && menu.url">
          <img :src="menu.url" alt="">
          <div>{{menu.name}}</div>
        </div>
      </div>

       <div class="menu-title">{{$t('mine.tab3')}}</div>
      <div class="menu-list">
        <div class="menu flex-column-center" v-for="(menu, i) in menuList3" :key="i" @click="toPath(menu.path)" v-if="menu.name && menu.url">
          <img :src="menu.url" alt="">
          <div>{{menu.name}}</div>
        </div>
      </div>

       <div class="menu-title">{{$t('mine.tab4')}}</div>
      <div class="menu-list">
        <div class="menu flex-column-center" v-for="(menu, i) in menuList4" :key="i" @click="toPath(menu.path)" v-if="menu.name && menu.url">
          <img :src="menu.url" alt="">
          <div>{{menu.name}}</div>
        </div>
      </div>
    </div>

    <div class="menu-box" v-show="!isLogin">
      <div class="menu-list">
        <div class="menu flex-column-center" v-for="(menu, i) in menuList5" :key="i" @click="toPath(menu.path)" v-if="menu.name && menu.url">
          <img :src="menu.url" alt="">
          <div>{{menu.name}}</div>
        </div>
      </div>
    </div>

    <div class="bottom-btn" v-if="isLogin">
      <Button class="logout-btn" @click="logout">{{$t('mine.btn2')}}</Button>
    </div>
  </div>
</template>
<script>
import { Popup, Button, Icon } from 'vant'
import { getToken, removeToken } from '@/utils/auth'
import { userInfo } from '@/api/user'
export default {
  components: {
    Popup,
    Button,
    Icon
  },
  data() {
    return {
      closeUrl: require('../../assets/imgs/icon-close.png'),
      username: '',
      userId: '',
      isLogin: false,
      RealNameStatus: ''
    }
  },
  computed: {
    menuList() {
      return [
				{
          url: require('../../assets/imgs/mine-menu1.png'),
					name: this.i18n.t('mine.menu1'),
          path: 'assestLog',
          query: {
            type: 5
          }
				},
				// {
        //   url: require('../../assets/imgs/mine-menu2.png'),
				// 	name: this.i18n.t('mine.menu2'),
        //   path: 'share'
				// },
        {
          url: require('../../assets/imgs/mine-menu3.png'),
					name: this.i18n.t('mine.menu3'),
          path: 'notice'
				},
        {
          url: require('../../assets/imgs/mine-menu4.png'),
					name: this.i18n.t('mine.menu4'),
          path: 'kefu'
				},
			]
    },
    menuList2() {
      return [
				{
          url: require('../../assets/imgs/mine-menu5.png'),
					name: this.i18n.t('mine.menu5'),
          path: 'userAuth'
				},
				{
          url: require('../../assets/imgs/mine-menu6.png'),
					name: this.i18n.t('mine.menu6'),
          path: 'editPassword'
				},
        {
          url: require('../../assets/imgs/mine-menu7.png'),
					name: this.i18n.t('mine.menu7'),
          path: 'editSafePassword'
				},
        {
          url: require('../../assets/imgs/mine-menu8.png'),
					name: this.i18n.t('mine.menu8'),
          path: 'address'
				},
			]
    },
    menuList3() {
      return [
				{
          url: require('../../assets/imgs/mine-menu9.png'),
					name: this.i18n.t('mine.menu9'),
          path: 'tradeSetting'
				},
				{
          url: require('../../assets/imgs/mine-menu10.png'),
					name: this.i18n.t('mine.menu10'),
          path: 'bit'
				},
        {
          url: require('../../assets/imgs/mine-menu11.png'),
					name: this.i18n.t('mine.menu11'),
          path: 'lang'
				}
			]
    },
    menuList4() {
      return [
				// {
        //   url: require('../../assets/imgs/mine-menu12.png'),
				// 	name: this.i18n.t('mine.menu12'),
        //   path: 'help'
				// },
				{
          url: require('../../assets/imgs/mine-menu13.png'),
					name: this.i18n.t('mine.menu13'),
          path: 'about'
				},
        {
          url: require('../../assets/imgs/mine-menu14.png'),
					name: this.i18n.t('mine.menu14'),
          path: 'feedback'
				},
        // {
        //   url: require('../../assets/imgs/mine-menu13.png'),
				// 	name: this.i18n.t('mine.menu15'),
        //   path: 'download'
				// },
			]
    },
    menuList5() {
      return [
				{
          url: require('../../assets/imgs/mine-menu10.png'),
					name: this.i18n.t('mine.menu10'),
          path: 'bit'
				},
				{
          url: require('../../assets/imgs/mine-menu11.png'),
					name: this.i18n.t('mine.menu11'),
          path: 'lang'
				},
        {
          url: require('../../assets/imgs/mine-menu12.png'),
					name: this.i18n.t('mine.menu12'),
          path: 'help'
				},
        {
          url: require('../../assets/imgs/mine-menu4.png'),
					name: this.i18n.t('mine.menu4'),
          path: 'kefu'
				},
        {
          url: require('../../assets/imgs/mine-menu13.png'),
					name: this.i18n.t('mine.menu15'),
          path: 'download'
				},
			]
    },
  },
  mounted() {
    if (getToken()) {
      this.isLogin = true
      this.init()
    }
  },
  methods: {
    init() {
      userInfo().then(res => {
        this.username = res.data.Email
        this.userId = res.data.ID
        this.RealNameStatus = res.data.RealNameStatus
      })
    },
    toPath(path, query) {
      if (path) {
        if (path === 'userAuth') {
          query = {
            status: this.RealNameStatus
          }
        }
        this.$router.push({
          name: path,
          query: query || {}
        })
      }
    },
    logout() {
      removeToken()
      this.$router.push({
        name: 'index'
      })
    },
    resetEmail(email) {
      if (!email) {
        return ''
      }
      let pre = email.substring(0, email.indexOf('@'))
      return pre.substring(0, 3) + '***' + email.substring(email.indexOf('@'))
    }
  }
}
</script>